module.exports = __webpack_public_path__ + "static/img/reading-logo.a16021f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingParty/reading-logo.png
// module id = DMHX
// module chunks = 0